import { DialogLocal } from "@/components/Dialog";
import { Input } from "@/components/Input";
import SubLayout from "@/components/SubLayout";
import { AutoCenter, Button, Form, Toast } from "antd-mobile";
import { useSetup, validateFields } from "./logic";
import { useUserInfoStore } from "@/stores/userInfo";
export function PageUserPwd() {
  const store = useSetup();
  const [userInfo] = useUserInfoStore()((state) => [state.userInfo]);

  const onSubmit = async () => {
    const values = await store.form.validateFields();
    const validateResult = validateFields(values, {
      isBindPwd: store.isBindPwd,
    });
    if (typeof validateResult === "string") {
      return Toast.show(validateResult);
    }
    if ( userInfo && !userInfo.isEnteredPassword ){
      if (store.isBindPwd) {
        store.fetchResetPwd(values);
      } else {
        store.fetchSetPwd(values);
      }
    }else{
      DialogLocal({
        content: (
          <AutoCenter>
            <div>
              为保障您的账户安全，登录密码修改后
              <span style={{ color: "#fb2222ff" }}> 7天 </span>
              以内不允许再次修改
            </div>
          </AutoCenter>
        ),
        onConfirm() {
          if (store.isBindPwd) {
            store.fetchResetPwd(values);
          } else {
            store.fetchSetPwd(values);
          }
        },
      });
    }
  };

  return (
    <SubLayout
      title={`${store.isBindPwd ? "修改" : "设置"}账户密码`}
      footer={
        <Button className={"common-submit-button"} onClick={() => {onSubmit()}}>
          确定
        </Button>
      }
    >
      <Form form={store.form} className={"common-form"}>
        {store.isBindPwd ? (
          <Form.Item name="oldPassword" label="旧密码">
            <Input
              placeholder="请输入6-15位字母数字组成的密码"
              type={"password"}
            />
          </Form.Item>
        ) : null}

        <Form.Item
          name="newPassword"
          label={`${store.isBindPwd ? "新" : ""}密码`}
        >
          <Input
            placeholder="请输入6-15位字母数字组成的密码"
            type={"password"}
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label={`确认${store.isBindPwd ? "新" : ""}密码`}
        >
          <Input
            placeholder="请输入6-15位字母数字组成的密码"
            type={"password"}
          />
        </Form.Item>
      </Form>
    </SubLayout>
  );
}
